<template>
  <table class="table table-striped propertyTable">
    <colgroup>
      <col width="35%" />
      <col width="65%" />
    </colgroup>

    <tbody>
      <tr>
        <td
          class="background-color-primary text-light align-middle"
          colspan="2"
        >
          {{ title }}
        </td>
      </tr>
      <slot name="iconProperties"></slot>

      <TableEntry
        v-for="i in entries"
        :key="i.title"
        :text="i.title"
        :value="i.value"
        :additionalPropertyText="i.additional"
      />
      <!-- This allows us to add custom entries to the table -->
      <slot></slot>
    </tbody>
  </table>
</template>

<script>
import TableEntry from "./TableEntry";
export default {
  name: "Table",
  components: {
    TableEntry,
  },
  props: {
    title: {
      type: String,
      default: "NoTitle",
    },
    entries: {
      type: Array,
      required: true,
      default: function () {
        return [];
      },
    },
  },
};
</script>

<style scoped></style>
